export enum LifeCycleStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Paused = 'Paused',
  Deleted = 'Deleted',
}
